import i18n from '@/locale/index'

export default [
  {
    path: '/metaIdCard',
    name: 'metaIdCard',
    component: () => import('../../views/metaIdCard/index.vue'),
    meta: {
      title: i18n.global.t('metaIdCard.c1'),
    }
  },
  {
    path: '/metaIdResult',
    name: 'metaIdResult',
    component: () => import('../../views/metaIdCard/result.vue'),
    meta: {
      title: i18n.global.t('metaIdCard.c1'),
    }
  },
]